import styled from 'styled-components'

export const Footer = styled('footer')`
  width: 100%;
  background: black;
  padding: 30px 0;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 34px;
  text-align: center;

  @media (max-width: 1000px) {
    font-size: 18px;
  }
  @media (max-width: 430px) {
    font-size: 15px;
  }
`
